import { render, staticRenderFns } from "./ExibirResposta.vue?vue&type=template&id=6a2bbe56&scoped=true&"
import script from "./ExibirResposta.vue?vue&type=script&lang=js&"
export * from "./ExibirResposta.vue?vue&type=script&lang=js&"
import style0 from "./ExibirResposta.vue?vue&type=style&index=0&id=6a2bbe56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bbe56",
  null
  
)

export default component.exports